<div class="flex h-full flex-col">
    <app-nav></app-nav>
    @if (authStore.isAuthorized()) {
        <mat-sidenav-container class="flex-1">
            <mat-sidenav
                [autoFocus]="false"
                class="!w-64"
                [opened]="true"
                mode="side">
                <mat-nav-list>
                    @for (item of sidenavItems(); track $index) {
                        <mat-list-item
                            routerLink="/{{ item.link }}"
                            routerLinkActive
                            #rla="routerLinkActive"
                            [activated]="rla.isActive">
                            <mat-icon
                                matListItemIcon
                                [fontSet]="item.iconFontSet!">
                                {{ item.icon }}
                            </mat-icon>
                            <span matListItemTitle>
                                {{ item.title }}
                            </span>
                        </mat-list-item>
                    }
                    <mat-list-item (click)="logout()">
                        <mat-icon matListItemIcon>logout</mat-icon>
                        <span matListItemTitle>Logout</span>
                    </mat-list-item>
                </mat-nav-list>
            </mat-sidenav>
            <mat-sidenav-content>
                <div class="h-full">
                    <router-outlet />
                </div>
            </mat-sidenav-content>
        </mat-sidenav-container>
    } @else {
        <div class="h-full">
            <router-outlet />
        </div>
    }
</div>
